import { Card, CardContent, CardHeader } from '@heidi/design-system/card';
import { Skeleton } from '@heidi/design-system/skeleton';

const TemplateCardSkeleton = () => {
  return (
    <Card className="flex w-full flex-col gap-3">
      <CardHeader className="flex flex-col gap-3 space-y-0 p-4 pb-0">
        <Skeleton className="h-3 w-16 rounded" />
        <Skeleton className="h-4 w-full max-w-64 rounded" />
      </CardHeader>
      <CardContent className="flex justify-between p-4 pt-0">
        <div className="flex flex-col gap-1">
          <Skeleton className="h-4 w-20 rounded" />
          <Skeleton className="h-4 w-20 rounded" />
        </div>
        <Skeleton className="h-4 w-16 self-end rounded" />
      </CardContent>
    </Card>
  );
};

export default TemplateCardSkeleton;
